module.exports = __webpack_public_path__ + "media/public/images/icon-favorite-hover-dc974699d1c686139e38c9ecbe6cd91e.svg";